import { render } from "./NcrmExternalApiEndpointSamplesCard.vue?vue&type=template&id=58972714&scoped=true"
import script from "./NcrmExternalApiEndpointSamplesCard.vue?vue&type=script&lang=js"
export * from "./NcrmExternalApiEndpointSamplesCard.vue?vue&type=script&lang=js"

import "./NcrmExternalApiEndpointSamplesCard.vue?vue&type=style&index=0&id=58972714&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58972714"]])

export default __exports__